import { Button, Dropdown, Tooltip } from '@getro/rombo';
import { ArrowLeftRight, FileSpreadsheet, RefreshCw, User, UserPlus } from 'lucide-react';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Box, Card, Flex } from 'rebass/styled-components';
import { activeNetworkSelector, userSelector } from '../../../redux/selectors';
import { HubspotMeetingsModal } from '../../../components/molecules/hubspotMeetingsModal';

export const ImportButton = () => {
  const activeNetwork = useSelector(activeNetworkSelector);
  const { linkedinSync } = useSelector(userSelector);
  const [showMeetingsModal, setShowMeetingsModal] = useState(false);

  return (
    <Flex sx={{ gap: '8px' }}>
      {!linkedinSync && (
        <Tooltip
          position="bottom"
          content="Connect your LinkedIn account to sync all your current and future connections."
          trigger={
            <Button
              as={NavLink}
              size="small"
              variant="tertiary"
              icon={RefreshCw}
              to={`/networks/${activeNetwork.slug}/linkedin/sync`}
            >
              Connect LinkedIn
            </Button>
          }
        />
      )}
      {linkedinSync && !activeNetwork.shareContacts && (
        <Tooltip
          content="Share your contacts to make them visible to other admins of this network."
          trigger={
            <Button
              as={NavLink}
              size="small"
              variant="tertiary"
              icon={ArrowLeftRight}
              to={`/networks/${activeNetwork.slug}/settings/my-networks`}
              iconGap="8px"
            >
              Share my contacts
            </Button>
          }
        />
      )}
      {activeNetwork.contactsOverLimit ? (
        <>
          <Button size="small" variant="accent" icon={UserPlus} onClick={() => setShowMeetingsModal(true)}>
            Add contacts
          </Button>
          {showMeetingsModal && <HubspotMeetingsModal kind="contacts" onCancel={() => setShowMeetingsModal(false)} />}
        </>
      ) : (
        <Dropdown
          placement="bottom-end"
          triggerProps={{
            variant: 'accent',
            id: 'add-contacts-dropdown-trigger',
            children: (
              <Flex alignItems="center" fontSize="14px">
                <Box as={UserPlus} mr="2" width="16px" height="16px" aria-hidden="true" />
                Add contacts
              </Flex>
            ),
            sx: {
              height: '32px',
            },
          }}
        >
          <Card px="0" py="8px" width="208px">
            <Flex
              as={NavLink}
              to={`/networks/${activeNetwork.slug}/contact/add`}
              height="32px"
              px="16px"
              sx={{
                fontSize: '14px',
                gap: '8px',
                alignItems: 'center',
                textDecoration: 'none',
                ':hover': { bg: 'neutral.50' },
              }}
            >
              <Box as={User} width="16px" height="16px" aria-hidden="true" />
              Add single contact
            </Flex>
            <Flex
              as={NavLink}
              to={`/networks/${activeNetwork.slug}/import-contacts/csv`}
              height="32px"
              px="16px"
              sx={{
                fontSize: '14px',
                gap: '8px',
                alignItems: 'center',
                textDecoration: 'none',
                ':hover': { bg: 'neutral.50' },
              }}
            >
              <Box as={FileSpreadsheet} width="16px" height="16px" aria-hidden="true" />
              Import CSV
            </Flex>
          </Card>
        </Dropdown>
      )}
    </Flex>
  );
};
